import {  useState, useNavigate, toast,  useEffect } from '../../common/common';
import Validation from '../../validation/Authentication/Validation.js';
import { useErrorContext } from '../../context/ErrorContext.js';
import { StartLoading, StopLoading } from '../../Utils/loadingUtils.js';
import Navigations from '../../common/useNavigation.js';
import axiosJWT from '../../secureAPI/axiosJWT.js';
import useGetUserData from '../../secureAPI/GetUserData';

const MidGeneralSettings = (usertype) => {
    const navigate = useNavigate();
    const { users } = useGetUserData();
    const [isLoading, setisLoading] = useState(false);
    const { validatePersonalDetailsForm } = Validation;
    const {  navigateSellerProductAttributes, navigateDashboard } = Navigations();
    // const { userType, setUserType } = useState(0);
    const [countryData, setCountryData] = useState([]);
    const [selectedCountryId, setSelectedCountryId] = useState(0);
    const [stateData, setStateData] = useState([]);
    const [selectedStateId, setSelectedStateId] = useState(0);
    const [EditedState, setEditedState] = useState();
    const [dbState, setdbState] = useState();
    const [cityData, setCityData] = useState([]);
    const [selectedCityId, setSelectedCityId] = useState(0);
    const [EditedCity, setEditedCity] = useState();
    const [dbCity, setdbCity] = useState();
    const { setValidationError, clearAllErrors } = useErrorContext();
    const [isIndian, setisIndian] = useState(null);
    const [values, setValue] = useState([]);

    useEffect(() => {
        const logUserData = () => {
        //   console.log({ users: users });
      
          if (users?.length > 0) {
            setValue({
                emailnmobi: users[0]['EmailAddress'],
                primaryContact: users[0]['Mobile'],
                isIndian: users[0]['IsIndian'],
                isPersonalDetails: users[0]['IsPersonalDetils'],
                companyName: users[0]['CompanyName'],
                companyInitials: users[0]['CompanyInitials'],
                contactnumber: users[0]['ContactNumber'],
                companyWebsite: users[0]['CompanyWebsite'],
                companyGST: users[0]['GSTNumber'],
                GSTDoc: users[0]['GSTDoc'],
                address1: users[0]['Address1'],
                address2: users[0]['Address2'],
                zipCode: users[0]['Pincode'],
                Country: users[0]['Country'],
                Country_name: users[0]['CountryName'],
                State: users[0]['State'],
                State_name: users[0]['StateName'],
                City: users[0]['City'],
                City_name: users[0]['CityName'],
            });
      
            if (users[0]['IsIndian'] === 0) {
              setisIndian(false);
              StopLoading(setisLoading);
              getCountries();
            } else {
              setisIndian(true);
              StopLoading(setisLoading);
              getstates(101, users[0]['State']);
              setSelectedStateId(parseInt(users[0]['State']));
              setdbState(users[0]['State']);
              setSelectedCountryId(101);
              
              const stateid = {
                label: users[0]['StateName'],
                value: users[0]['State']
              };
              getCities(stateid);
              setdbCity(users[0]['City']);
              setSelectedCityId(users[0]['City']);
            }
          }
        };
      
        if (Array.isArray(users) && users.length > 0) {
        //   console.log('useEffect called, users:', users);
          logUserData();
        }
      }, [users, dbState]); // No more missing dependency
    // useEffect(() => {
    //     //  console.log('called useeffectsss');
    //     if (Array.isArray(users) && users.length > 0) {
    //         console.log('useEffect called, users:', users);
    //         logUserData();
    //     }
    // }, [users, dbState]);

    // const logUserData = () => {
    //     console.log({ users: users });

    //     if (users?.length > 0) {
    //         setValue({
    //             emailnmobi: users[0]['EmailAddress'],
    //             primaryContact: users[0]['Mobile'],
    //             isIndian: users[0]['IsIndian'],
    //             isPersonalDetails: users[0]['IsPersonalDetils'],
    //             companyName: users[0]['CompanyName'],
    //             companyInitials: users[0]['CompanyInitials'],
    //             contactnumber: users[0]['ContactNumber'],
    //             companyWebsite: users[0]['CompanyWebsite'],
    //             companyGST: users[0]['GSTNumber'],
    //             GSTDoc: users[0]['GSTDoc'],
    //             address1: users[0]['Address1'],
    //             address2: users[0]['Address2'],
    //             zipCode: users[0]['Pincode'],
    //             Country: users[0]['Country'],
    //             Country_name: users[0]['CountryName'],
    //             State: users[0]['State'],
    //             State_name: users[0]['StateName'],
    //             City: users[0]['City'],
    //             City_name: users[0]['CityName'],

    //         });

    //         if (users[0]['IsIndian'] === 0) {
    //             setisIndian(false)
    //             StopLoading(setisLoading);
    //             getCountries();  // Fetch country if IsIndian is 0
    //         } else {
    //             setisIndian(true)
    //             StopLoading(setisLoading);
    //             getstates(101, users[0]['State']);
    //             setSelectedStateId(parseInt(users[0]['State']));
    //             setdbState(users[0]['State']);


    //             setSelectedCountryId(101);
    //             const stateid = {
    //                 label: users[0]['StateName'],
    //                 value: users[0]['State']
    //             };
    //             getCities(stateid);
    //             setdbCity(users[0]['City']);
    //             setSelectedCityId(users[0]['City']);
    //         }

    //     }
    // };


    const handleGetState = (id) => {

        setSelectedCountryId(id)
        getstates(id, 0);
    }
    const handleGetCities = (id) => {

        setSelectedStateId(id.value)
        getCities(id);
    }
    const handleSetCityId = (id) => {

        setSelectedCityId(id.value)
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        const updatedValue = name === 'companyGST' ? value.toUpperCase() : value;
        setValue(prevValues => ({ ...prevValues, [name]: updatedValue }));
        if (Object.keys(validateAndSetErrors(values)).length === 0) clearAllErrors();
    };


    const handleFileChange = ({ target: { files } }) => {
        setValue(prevValues => ({ ...prevValues, file: files[0] }));
    };


    // Reusable function to handle validation and set errors
    const validateAndSetErrors = (values) => {
        const validationErrors = validatePersonalDetailsForm(values);
        Object.keys(validationErrors).forEach(field => setValidationError(field, validationErrors[field]));
        return validationErrors;
    };


    const handleSubmit = e => {
        e.preventDefault();
        const validationErrors = validateAndSetErrors(values);

        if (Object.keys(validationErrors).length === 0) {
            clearAllErrors();
            SubmitPersonalDetails(); // Assuming checkLogin() is a function to handle actual login logic
        }
    };
    const SubmitPersonalDetails = () => {
        // console.log({ values: values });
        let final_user_type;
        const { emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, zipCode, file } = values;
        //   const data = { emailnmobi, primaryContact, companyName, companyInitials, companyWebsite, companyGST, address1, address2, Country, State, City, zipCode, file };
        if (usertype === 'buyer' || usertype === 'Buyer') {
            final_user_type = 1;
            if (!emailnmobi || !companyName || !companyInitials || !address1 || !selectedCountryId || !selectedStateId || !selectedCityId || !zipCode) {
                showToast('Please fill all required fields', 'error');
                return;
            }
        } else if (usertype === 'seller' || usertype === 'Seller') {
            final_user_type = 2;


            // console.log(emailnmobi + '/' + primaryContact + '/' + companyName + '/' + companyInitials + '/' + address1 + '/' + selectedCountryId + '/' + selectedStateId + '/' + selectedCityId + '/' + zipCode)
            if (!emailnmobi || !primaryContact || !companyName || !companyInitials || !address1 || !selectedCountryId || !selectedStateId || !selectedCityId || !zipCode) {
                showToast('Please fill all required fields', 'error');
                return;
            }
        } else {
            final_user_type = 0;
        }
        var formData = new FormData();
        formData.append("UserTypes", final_user_type);
        formData.append("primaryContact", primaryContact);
        formData.append("email", emailnmobi);
        formData.append("companyName", companyName);
        formData.append("companyInitials", companyInitials);
        formData.append("companyWebsite", companyWebsite);
        formData.append("companyGST", companyGST);
        if (file) { formData.append("file", file); }
        formData.append("address1", address1);
        formData.append("address2", address2);
        formData.append("country", selectedCountryId);
        formData.append("states", selectedStateId);
        formData.append("city", selectedCityId);
        formData.append("zipCode", zipCode);
        formData.append("userType", usertype);
        // console.log({ formData: formData });
        axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/UpdatePersonalDetails`, formData, { withCredentials: true, credentials: 'include' })
            .then(handlePersonalDetailsResponse)
            .catch(handlePersonalDetailsError);
    };
    const showToast = (message, type) => {
        const options = {
            position: 'top-center',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
        };

        if (type === 'success') {
            toast.success(message, options);
        } else {
            toast.error(message, options);
        }
    };
    const clearForm = () => {
        values.fullName = "";
        values.emailAddress = "";
        values.mobileNumber = "";
        values.passWord = "";
    };


    const handlePersonalDetailsResponse = (res) => {
        const result = res.data;
        // console.log({ result: result });
        if (result.success === 1) {
            handleSuccessfulPersonalDetails(result);
        } else {
            showToast(result.message, 'error');
        }

        resetLoadingState();
    };
    const handleSuccessfulPersonalDetails = (result) => {
        const { message, resuserType } = result;
        // console.log(resuserType)
        showToast(message, 'success');
        clearForm();
        if (resuserType === "1,2") {
            navigateSellerProductAttributes();
        }
        else if (resuserType === "1") {
            navigateDashboard('Buyer');
        }
    };
    const handlePersonalDetailsError = (err) => {
        console.error(err);
        showToast('Something went wrong! Please try again later', 'error');
        resetLoadingState();
    };
    const resetLoadingState = () => {
        setisLoading(false);
    };
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);

    const getCountries = async () => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcountries`,).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(country => ({
                        label: country.name, // Country name as label
                        value: country.id,   // Country ID as value
                    }));
                    // console.log({ transformedData: transformedData });
                    setCountryData(transformedData);
                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => { });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find countries, please try again later ", 'error');
        }
    };
    const getstates = async (country_id, db_State) => {

        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getstates`, { countryid: country_id, }).then((res) => {
                StopLoading(setisLoading);
                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(state => ({
                        label: state.name, // Country name as label
                        value: state.id,   // Country ID as value
                    }));
                    // console.log({ transformedData: transformedData });
                    setStateData(transformedData);

                    const defaultCountry = transformedData.find(country => country.value === db_State);
                    setEditedState(defaultCountry);

                    // const defaultstate = transformedData.find(state => state.id === parseInt(values.State));
                    // console.log({defaultstate:defaultstate});
                    // setEditedState(defaultstate);

                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find cities, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find States, please try again later ", 'error');
        }
    };
    const getCities = async (stateid) => {
        StartLoading(setisLoading);
        try {
            await axiosJWT.post(`${process.env.REACT_APP_API_URL}/api/Getcities`, { stateid: stateid }).then((res) => {
                StopLoading(setisLoading);

                if (res.data.success === 1) {
                    const transformedData = res.data.data.map(city => ({
                        label: city.name,
                        value: city.id,
                    }));
                    // console.log({ transformedData: transformedData });
                    setCityData(transformedData);
                    const defaultCountry = transformedData.find(country => country.value === dbCity);
                    setEditedCity(defaultCountry);


                }
                else {
                    showToast(res.data.message, 'error');
                }
            })
                .catch((err) => {
                    StopLoading(setisLoading);
                    showToast("Failed to find cities, please try again later ", 'error');
                });
        } catch (err) {
            StopLoading(setisLoading);
            showToast("Failed to find cities, please try again later ", 'error');
        }
    };

    return {
        users,
        values, isLoading, handleSubmit, handleChange, handleFileChange, countryData, getCities, getstates, selectedCity, selectedCountry, selectedState, handleSetCityId, isIndian, stateData, cityData, handleGetCities, handleGetState, selectedStateId, selectedCityId, EditedState, EditedCity
    }
}

export default MidGeneralSettings